<template>
  <div class="container">
    <div class="inner-container">
      <div class="logo-wrapper">
        <img class="logo-img" src="/imgs/logo.png" @click="toHome">
      </div>

      <ul class="nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="item.id"
          @click="toList(item, index)"
        >
          {{item.title}}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import axios from 'axios'
import { requestUrl, orgId } from '../common/constant'

export default {
  name: 'LogoAndNav',
  props: {
    navList: {
      type: Array,
      required: true
    }
  },
  methods: {
    ...mapMutations([
      'updateMainColumnId',
      'updateArticleId'
    ]),
    toHome () {
      this.$router.push({
        path: '/'
      }
      )
      // this.updateMainColumnId(0)
    },
    async toList (item, index) {
      if (index === 0) {
        this.updateMainColumnId(0)
        this.$router.push('/')
      } else {
        if (item.type === 'channel') {
          this.updateMainColumnId(item.colmun_id)
          this.$router.push(`/news/${item.colmun_id}`)
        } else {
          const result = await axios.get(`${requestUrl}/news/article?id=${item.colmun_id}&orgId=${orgId}`)
          const articleId = result.data[0].id
          this.$router.push({
            path: `/content/${articleId}`
          })
          this.updateMainColumnId(item.colmun_id)
          this.updateArticleId(articleId)
        }
      }
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
}

.inner-container {
  width: 1190px;
  height: 100%;
  display: flex;
  justify-content: space-between;
}

.logo-wrapper {
  padding: 10px 0;
}

.logo-img {
  height: 60px;
  margin-top: 10px;
  cursor: pointer;
}

.nav-wrapper {
  display: flex;
  align-items: center;
  width: 50%;
  justify-content: space-between;
  margin-right: 20px;
}

.nav-wrapper li {
  font-weight: 700;
  color: #444;
}

.nav-wrapper li:hover {
  cursor: pointer;
  color: #132978;
}

</style>
